import { Icon, IconProps, Info } from "Components/Icons";
import { Button, Tooltip, TooltipProps } from "Components/ReactstrapSlim";
import { useUniqueId } from "Hooks";
import React, { useState } from "react";
import classes from "./styles.module.scss";

interface InfoIconProps extends IconProps {
   onClaim: () => void;
   tooltipPlacement?: TooltipProps["placement"];
}

const InfoIcon = React.forwardRef<Icon, InfoIconProps>(({ onClaim, tooltipPlacement, ...rest }, ref) => {
   const infoIconId = useUniqueId("cyp-info-icon-");
   const [isOpen, setOpen] = useState(false);
   return <>
      <Info id={infoIconId} {...rest} />
      <Tooltip isOpen={isOpen} toggle={_ => setOpen(x => !x)} placement={tooltipPlacement} target={infoIconId} autohide={false} innerClassName={classes["tooltip-content"]}>
         <div>This profile has not yet been claimed by the owner or a representative.</div>
         <div>
            <Button color="link" className={classes.cta} onClick={_ => { setOpen(false); onClaim(); }}>
               Claim this profile
            </Button>
            {" "}
            to receive leads, bookings and messages from prospective customers.</div>
      </Tooltip>
   </>
});

export default InfoIcon;